export default __webpack_public_path__ + "static/media/Leaves.a17be8d1.svg";